import { ApiResponse } from './ApiResponse';
import { Settings } from '../Settings';
import 'whatwg-fetch'
import { Common } from '../Common';

export class ApiManager {

    public getAddress(method: string, params: Record<string, any>) {
        let paramsStr: string = "";

        for (let key in params) {
            let value = encodeURIComponent(params[key]);
            paramsStr += `&${key}=${value}`;
        }

        let apiEndpoint: string;
        if (Common.IsDebugEnvironment()) {
            apiEndpoint = Settings.ApiEndPointDebug;
        } else {
            apiEndpoint = Settings.ApiEndPointProduction;
        }

        return `${ apiEndpoint }?method=${ method }${ paramsStr }`;
    }

    public MakeRequest(method: string, params: Record<string, any> = {}) : Promise<ApiResponse> {
        return new Promise<ApiResponse>((onCompleted, onFailed) => {
            fetch(this.getAddress(method, params), {
                    credentials: "include"
                })
                .then(resp => resp.json())
                .then(json => onCompleted(json as ApiResponse))
                .catch(ex => onFailed(ex))
        });
    }

    public SubmitForm(method: string, form: HTMLFormElement) : Promise<ApiResponse> {
        return new Promise<ApiResponse>((onCompleted, onFailed) => {
            fetch(this.getAddress(method, {}), {
                    method: "POST",
                    body: new FormData(form),
                    credentials: "include"
                })
                .then(resp => resp.json())
                .then(json => onCompleted(json as ApiResponse))
                .catch(ex => onFailed(ex))
        });
    }
}
